import { ApiModule, type PaginatedResponseData } from '@common/index';
import type { YearlyEventItem, YearlyEvent } from '../models';

export class YearlyEventApi extends ApiModule {
  protected endpoint = '/yearly-event';

  public async pageYearlyEvents(params: any) {
    return this.api.post<PaginatedResponseData<YearlyEventItem>, any>(
      `${this.endpoint}/page?page=${params.page}&size=${params.itemsPerPage}&sort=${params.sort ?? ''}&sort=${params.sort ?? ''}`,
      {
        ...params
      }
    );
  }

  public loadYearlyEventDetails(id: number) {
    return this.api.get<YearlyEvent>(`${this.endpoint}?id=${id}`);
  }

  public saveYearlyEvent(params: any) {
    return this.api.post(`${this.endpoint}`, {
      ...params
    });
  }

  public deleteYearlyEvent(id: number) {
    return this.api.delete(`${this.endpoint}?id=${id}`);
  }
}
